module.exports = __webpack_public_path__ + "assets/images/splash-fce3106d2b4e52ffcf2dd8542af4b4f2.png";